import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ContentsItem from './ContentsItem';

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

class ContentsMng extends Component {
    
    // 스크롤 이동 기능
    handleScrollClick = (direct) => {
        this.handleScrollLeave();
        this.handleScrollMove(direct, 300);
    };
    handleScrollEnter = (direct) => {
        this.interval = setInterval(() => this.handleScrollMove(direct, 5), 20);
    };
    handleScrollLeave = () => {
        clearInterval(this.interval);
    };
    handleScrollMove = (direct, size) => {
        if (direct === "left") this.myRef.scroll({ top: 0, left: this.myRef.scrollLeft - size, behavior: (size > 100 ? "smooth" : "auto") });
        if (direct === "right") this.myRef.scroll({ top: 0, left: this.myRef.scrollLeft + size, behavior: (size > 100 ? "smooth" : "auto") });
    };
    
    // 추가 기능
    setContentListAdd = (addList, addContentType) => {
        let contentList = (addContentType === "addSelectContent" ? this.props.contentList : []);
        let deleteContentIDs = (addContentType === "addOpbContent" ? this.props.contentList.map(board => board.opbcontentID) : []);

        addList.map(content => contentList = contentList.concat(content));
        const statusKey = (this.props.contentsTypeCode === "CT002" ? "promotionStatus" : this.props.contentsTypeCode === "CT003" ? "marketingStatus" : "bottomStatus");
        const targetKey = (this.props.contentsTypeCode === "CT002" ? "promotionList" : this.props.contentsTypeCode === "CT003" ? "marketingList" : "bottomList");

        this.props.setContentsStatus(statusKey, targetKey, contentList, deleteContentIDs);
    };

    // 제거 기능
    setContentListDel = (index) => {
        let contentList = this.props.contentList.filter((content, i) => i !== index);
        let deleteContentIDs = [this.props.contentList[index].opbcontentID];
        const statusKey = (this.props.contentsTypeCode === "CT002" ? "promotionStatus" : this.props.contentsTypeCode === "CT003" ? "marketingStatus" : "bottomStatus");
        const targetKey = (this.props.contentsTypeCode === "CT002" ? "promotionList" : this.props.contentsTypeCode === "CT003" ? "marketingList" : "bottomList");

        this.props.setContentsStatus(statusKey, targetKey, contentList, deleteContentIDs);
    };

    // 수정 기능
    setContentListMod = (content, index) => {
        let preContentList = [...this.props.contentList];
        preContentList[index] = content;
        const statusKey = (this.props.contentsTypeCode === "CT002" ? "promotionStatus" : this.props.contentsTypeCode === "CT003" ? "marketingStatus" : "bottomStatus");
        const targetKey = (this.props.contentsTypeCode === "CT002" ? "promotionList" : this.props.contentsTypeCode === "CT003" ? "marketingList" : "bottomList");

        this.props.setContentsStatus(statusKey, targetKey, preContentList);
    };

    // 드래그앤드랍 기능
    onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        if (result.source.index === result.destination.index) {
            return;
        }

        const statusKey = (this.props.contentsTypeCode === "CT002" ? "promotionStatus" : this.props.contentsTypeCode === "CT003" ? "marketingStatus" : "bottomStatus");
        const targetKey = (this.props.contentsTypeCode === "CT002" ? "promotionList" : this.props.contentsTypeCode === "CT003" ? "marketingList" : "bottomList");

        const contentList = reorder(
            this.props.contentList,
            result.source.index,
            result.destination.index
        );

        this.props.setContentsStatus(statusKey, targetKey, contentList);
    };


    render() {
        const { contentList, coBeginDate, coEndDate } = this.props;

        return (
            <>
                {/* <!-- 컨텐츠설정_템플릿설정 --> */}
                <div className="s-cont-wrap">
                    <div className="s-flex-auto">
                        <div className="s-drag-box hor" style={{ position: "relative" }}>
                            {contentList && contentList.length !== 0 &&
                                <p className="s-drag-msg">드래그해서 원하는 위치에 놓으세요.</p>
                            }
                            {/* <!-- 좌/우 화살표 --> */}
                            <div className="s-scroll-arrow">
                                <div className="s-scroll-left"
                                    onClick={() => { this.handleScrollClick("left") }}
                                    onMouseEnter={() => { this.handleScrollEnter("left") }}
                                    onMouseLeave={this.handleScrollLeave}
                                >
                                    왼쪽으로
                                </div>
                                <div className="s-scroll-right"
                                    onClick={() => { this.handleScrollClick("right"); }}
                                    onMouseEnter={() => { this.handleScrollEnter("right") }}
                                    onMouseLeave={this.handleScrollLeave}
                                >
                                    오른쪽으로
                                </div>
                            </div>

                            <div className="s-drag-area" ref={(ref) => { this.myRef = ref }}>
                                <DragDropContext onDragEnd={this.onDragEnd}>
                                    <Droppable droppableId="droppable" direction="horizontal">
                                        {provided => (
                                            <div
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                            >
                                                {contentList && contentList.length !== 0 &&
                                                    contentList.map((content, i) => (
                                                        <Draggable key={i} draggableId={`item_` + i} index={i} >
                                                            {provided2 => (
                                                                <div
                                                                    ref={provided2.innerRef}
                                                                    {...provided2.draggableProps}
                                                                    {...provided2.dragHandleProps}
                                                                >
                                                                    <ContentsItem key={i} content={content} index={i}
                                                                        contentsTypeCode={this.props.contentsTypeCode}
                                                                        coBeginDate={coBeginDate} coEndDate={coEndDate}
                                                                        setContentListDel={this.setContentListDel}
                                                                        setContentListMod={this.setContentListMod}
                                                                    />
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))
                                                }
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                                {contentList.length === 0 &&
                                    <div className="text-align-center" style={{ margin: "auto" }}>
                                        <img className="ic-add" src="/assets/images/dialog/ic-add.svg" alt="컨텐츠추가" /><br />
                                        등록된 컨텐츠가 없어 기본 컨텐츠가 재생중입니다.<br />
                                        추가 버튼을 눌러 컨텐츠를 추가하세요.
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}

export default ContentsMng;